import arMessages from '../locales/ar-AR.json';
import arAR from 'antd/lib/locale/ar_EG';

const ArLang = {
  messages: {
    ...arMessages,
  },
  antLocale: arAR,
  locale: 'ar-AR',
};
export default ArLang;
